(() => {
  const CONFIG = {
    'calm-feeding-set': [
      { option: 'Slow Feeder Color', label: 'Slow Feeder', handle: 'slow-feeder-bowl-for-cats-dogs-slower-calmer-mealtimes', matchOption: 'Color', useSingleProductSwatch: true },
      { option: 'Water Bowl Color', label: 'Water Bowl', handle: 'elevated-anti-splash-floating-cat-water-bowl', matchOption: 'Color', useSingleProductSwatch: true }
    ],
    'care-go-set': [
      { option: 'Bottle Color', label: 'Bottle', handle: 'portable-dog-water-bottle-with-food-storage-2-in-1-travel-bottle-for-dogs-cats', matchOption: 'Color' },
      { option: 'Brush Color', label: 'Brush', handle: '3-in-1-pet-mist-grooming-brush-deshed-detangle-refresh', matchOption: 'Color' }
    ]
  };

  const SINGLE_PRODUCT_SWATCH_BY_VARIANT = {
    'slow-feeder-bowl-for-cats-dogs-slower-calmer-mealtimes': {
      'Blush Pink': { mediaId: '53069812138301', tone: 'conic-gradient(from 45deg,#e0af65 0 25%,#b33953 25% 52%,#51aeb7 52% 76%,#85b54c 76% 100%)' },
      'Sunny Yellow': { mediaId: '53069812171069', tone: 'linear-gradient(135deg,#f0d36d 0 58%,#cf9c1e 58% 100%)' },
      'Coral Orange': { mediaId: '53069812203837', tone: 'conic-gradient(from 45deg,#c34d3f 0 38%,#ef9b9f 38% 66%,#e9c64d 66% 82%,#83ad55 82% 100%)' },
      'Sage Green': { mediaId: '53069812236605', tone: 'conic-gradient(from 45deg,#6ea92d 0 38%,#8cc24b 38% 56%,#9bb8d4 56% 78%,#e0c85f 78% 100%)' }
    },
    'elevated-anti-splash-floating-cat-water-bowl': {
      'Midnight Black + Blush Pink': { mediaId: '53069289488701', tone: 'linear-gradient(135deg,#e83a88 0 52%,#171817 52% 100%)' },
      'Sky Blue + Sunny Yellow': { mediaId: '53069289521469', tone: 'linear-gradient(135deg,#a8c8e0 0 55%,#765243 55% 100%)' },
      'Ivory White + Blush Pink': { mediaId: '53069289455933', tone: 'linear-gradient(135deg,#f2c9cf 0 52%,#d5c5b5 52% 100%)' },
      'Sage Green + Blush Pink': { mediaId: '53069289390397', tone: 'linear-gradient(135deg,#a8b37b 0 55%,#f2c9d3 55% 100%)' },
      'Color 5': { mediaId: '53069289423165', tone: 'conic-gradient(from 45deg,#b78dd5 0 36%,#e3be68 36% 70%,#f3da9e 70% 100%)' }
    }
  };

  const COLOR_TONES = {
    'white': '#f3f1ec', 'cloud white': '#f3f1ec', 'ivory white': '#f3f1ec',
    'yellow': '#e7bd35', 'sunny yellow': '#f2c84b', 'purple': '#8d72b6',
    'mint green': '#9fd8c6', 'blush pink': '#efb5c4', 'coral orange': '#f48a68',
    'sage green': '#a8b995', 'midnight black': '#252525', 'sky blue': '#91cbe8',
    'color 5': ['#d6c2a6', '#d8e8ef']
  };

  const norm = value => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const currentHandle = () => {
    const match = location.pathname.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  };
  const optionGroup = (root, name) => [...root.querySelectorAll('.pl-option[data-option-position]')]
    .find(group => {
      const legend = (group.querySelector('legend')?.textContent || '').replace(/:\s*.*$/, '').trim();
      return legend === name || (group.querySelector('legend')?.textContent || '').trim().startsWith(`${name}:`);
    });
  const selectedValue = group => group?.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '';
  const productJson = async handle => {
    const response = await fetch(`/products/${handle}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error(`Unable to load ${handle}`);
    return response.json();
  };
  const optionIndex = (product, name) => (product?.options || []).findIndex(option => (typeof option === 'string' ? option : option?.name) === name);
  const optionValues = (product, name) => {
    const index = optionIndex(product, name);
    if (index < 0) return [];
    return [...new Set((product?.variants || []).map(variant => String(variant.options?.[index] || '')).filter(Boolean))];
  };
  const variantForValue = (product, name, value) => {
    const index = optionIndex(product, name);
    if (index < 0 || !value) return null;
    const variants = product?.variants || [];
    return variants.find(variant => norm(variant.options?.[index]) === norm(value) && variant.available)
      || variants.find(variant => norm(variant.options?.[index]) === norm(value))
      || null;
  };
  const imageSrc = image => typeof image === 'string' ? image : image?.src || image?.url || '';
  const imageForValue = (product, name, value) => {
    const variant = variantForValue(product, name, value);
    return imageSrc(variant?.featured_image) || imageSrc(product?.featured_image) || imageSrc(product?.images?.[0]);
  };
  const imageKey = src => {
    try {
      return new URL(src || '', location.origin).pathname.replace(/_(?:pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '');
    } catch (_) { return String(src || '').split('?')[0]; }
  };
  const toneForValue = value => {
    const key = norm(value);
    const direct = COLOR_TONES[key];
    if (direct) return Array.isArray(direct) ? `linear-gradient(90deg, ${direct[0]} 0 50%, ${direct[1]} 50% 100%)` : direct;
    const parts = key.split(/\s+\+\s+/).map(part => part.trim()).filter(Boolean);
    if (parts.length >= 2) {
      const aRaw = COLOR_TONES[parts[0]], bRaw = COLOR_TONES[parts[1]];
      if (aRaw && bRaw) {
        const a = Array.isArray(aRaw) ? aRaw[0] : aRaw;
        const b = Array.isArray(bRaw) ? bRaw[0] : bRaw;
        return `linear-gradient(90deg, ${a} 0 50%, ${b} 50% 100%)`;
      }
    }
    return '#d9dcda';
  };
  const exactSingleProductTone = (handle, value) => SINGLE_PRODUCT_SWATCH_BY_VARIANT[handle]?.[value]?.tone || '';
  const applyTone = (swatch, tone, toneValue) => {
    tone.style.setProperty('background', toneValue, 'important');
    if (/gradient\(/.test(toneValue)) swatch.style.removeProperty('--pl-swatch-color');
    else swatch.style.setProperty('--pl-swatch-color', toneValue);
  };
  const ensureButton = (group, value) => {
    let button = [...group.querySelectorAll('[data-option-value]')].find(item => norm(item.dataset.optionValue) === norm(value));
    if (button) return button;
    button = document.createElement('button');
    button.type = 'button';
    button.className = 'pl-option__button is-swatch';
    button.dataset.optionValue = value;
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', value);
    button.title = value;
    button.innerHTML = '<span class="pl-swatch"><span class="pl-swatch__tone" aria-hidden="true"></span></span><span class="visually-hidden"></span>';
    const hidden = button.querySelector('.visually-hidden');
    if (hidden) hidden.textContent = value;
    group.querySelector('.pl-option__values')?.appendChild(button);
    return button;
  };
  const decorateSwatch = (button, src, value, item) => {
    if (!button) return;
    button.classList.add('pl-option__button', 'is-swatch');
    if (src) button.dataset.variantImage = src;
    let swatch = button.querySelector('.pl-swatch');
    if (!swatch) { swatch = document.createElement('span'); swatch.className = 'pl-swatch'; button.prepend(swatch); }
    if (src) {
      let image = swatch.querySelector('.pl-swatch__image');
      if (!image) { image = document.createElement('img'); image.className = 'pl-swatch__image'; image.loading = 'lazy'; swatch.prepend(image); }
      image.src = src;
      image.alt = value;
      image.decoding = 'async';
    }
    let tone = swatch.querySelector('.pl-swatch__tone');
    if (!tone) { tone = document.createElement('span'); tone.className = 'pl-swatch__tone'; tone.setAttribute('aria-hidden', 'true'); swatch.appendChild(tone); }
    const exactTone = item.useSingleProductSwatch ? exactSingleProductTone(item.handle, value) : '';
    const toneValue = exactTone || toneForValue(value);
    button.dataset.swatchTone = toneValue;
    button.dataset.swatchToneSource = exactTone ? 'single-product-bound-media-id' : 'variant-image';
    if (exactTone) button.dataset.boundMediaId = SINGLE_PRODUCT_SWATCH_BY_VARIANT[item.handle]?.[value]?.mediaId || '';
    applyTone(swatch, tone, toneValue);
  };
  const restoreTones = root => root.querySelectorAll('[data-swatch-tone]').forEach(button => {
    const swatch = button.querySelector('.pl-swatch');
    const tone = button.querySelector('.pl-swatch__tone');
    if (swatch && tone && button.dataset.swatchTone) applyTone(swatch, tone, button.dataset.swatchTone);
  });
  const updateLabel = (group, value) => {
    if (!group || !value) return;
    const label = group.querySelector('[data-option-label]') || group.querySelector('legend strong');
    if (label) label.textContent = value;
  };
  const syncGallery = (root, src) => {
    if (!src) return;
    const main = root.querySelector('.pl-gallery__main');
    if (main) {
      main.src = src;
      main.removeAttribute('srcset');
      main.setAttribute('data-linked-bundle-image', 'true');
    }
    const key = imageKey(src);
    root.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
      const thumbSrc = thumb.dataset.src || thumb.querySelector('img')?.src || '';
      thumb.classList.toggle('is-active', imageKey(thumbSrc) === key);
    });
  };

  const init = async () => {
    const handle = currentHandle();
    const config = CONFIG[handle];
    const root = document.querySelector('[data-powlife-product]');
    if (!config || !root || root.dataset.linkedBundleTemplateV3 === 'true') return;
    root.dataset.linkedBundleTemplateV3 = 'true';

    const loaded = {};
    await Promise.all(config.map(async item => {
      try { loaded[item.handle] = await productJson(item.handle); }
      catch (_) { loaded[item.handle] = null; }
    }));

    config.forEach(item => {
      const group = optionGroup(root, item.option);
      const product = loaded[item.handle];
      if (!group || !product) return;
      group.dataset.bundleComponentProduct = item.handle;
      optionValues(product, item.matchOption).forEach(value => {
        const button = ensureButton(group, value);
        decorateSwatch(button, imageForValue(product, item.matchOption, value), value, item);
      });
    });

    let activeItem = config[0];
    const syncItem = item => {
      const group = optionGroup(root, item.option);
      const product = loaded[item.handle];
      if (!group || !product) return;
      const value = selectedValue(group);
      if (!value) return;
      updateLabel(group, value);
      const image = imageForValue(product, item.matchOption, value);
      if (item === activeItem) syncGallery(root, image);
      restoreTones(root);
    };
    const syncActive = () => syncItem(activeItem);

    restoreTones(root);
    requestAnimationFrame(() => restoreTones(root));
    setTimeout(() => restoreTones(root), 120);
    syncActive();

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-option-value]');
      if (!button || !root.contains(button)) return;
      const group = button.closest('.pl-option[data-option-position]');
      const item = config.find(entry => optionGroup(root, entry.option) === group);
      if (!item) return;
      activeItem = item;
      requestAnimationFrame(() => {
        setTimeout(syncActive, 0);
        setTimeout(syncActive, 60);
        setTimeout(syncActive, 140);
      });
    }, true);

    root.addEventListener('change', event => {
      if (event.target.matches?.('[data-variant-select]')) {
        setTimeout(syncActive, 0);
        setTimeout(syncActive, 80);
      }
    }, true);

    document.addEventListener('powlife:bundle-refresh', syncActive);
  };

  const boot = () => init();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();